export default __webpack_public_path__ + "static/media/czlowiek2.3522b503.svg";